export default __webpack_public_path__ + "media/images/landing-23-550x420-7a8a07fd1d36a226d48b4b0e5261d3f1.jpg";